// extracted by mini-css-extract-plugin
var _1 = "SelectDropdownList-moduleSelectDropdownList__xvHZa SelectDropdown-moduleSelectDropdown__s9tE2";
export { _1 as "SelectDropdownList" }
